/**
 * Speaking content type
 */

import pkgJson from '../package.json';

export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

export {
    speakingSchema,
    defaultSpeakingConfig,
    defaultSpeakingData,
    defaultSpeakingI18n,
    type SpeakingContent,
    type SpeakingData,
    type SpeakingItem,
    type SpeakingConfig,
    type SpeakingScoringConfig,
    type SpeakingLayoutConfig,
    type SpeakingSplitRatio,
    type PageElementData,
    SPEAKING_GRADING_QUESTION_TYPES,
    SPEAKING_QUESTION_TYPES_WITH_PICTURE,
    DEFAULT_SPEAKING_GRADING_QUESTION_TYPE,
} from './schema';

export {
    SpeakingGradingTypeField,
    type SpeakingGradingTypeFieldProps,
} from './SpeakingGradingTypeField';

export {
    SpeakingGradingExampleDialog,
    type SpeakingGradingExampleDialogProps,
} from './SpeakingGradingExampleDialog';

export { SpeakingEdit, type SpeakingEditProps } from './SpeakingEdit';

export { SpeakingPlayer, type SpeakingPlayerProps } from './SpeakingPlayer';

export { SpeakingAiGradePanel, type SpeakingAiGradePanelProps } from './SpeakingAiGradePanel';

export {
    SpeakingPronunciationPanel,
    type SpeakingPronunciationPanelProps,
} from './SpeakingPronunciationPanel';

export {
    speakingContentGrader,
    gradeSpeaking,
    validateSpeakingAnswer,
    countSpeakingQuestions,
    speakingQuestionCounter,
    speakingPromptText,
    type SpeakingPronunciationEntry,
} from './scorer';

export { speakingSchema as default } from './schema';

export { speakingValidator } from './validator';
